export const DEFAULT_VARIANT = 'root';
export const DEFAULT_VARIANT_MAPPING: { [key: string]: string } = {
  root: '',
  filled: 'pageHeader--filled',
};
export const VARIANT_SCALE = Object.keys(DEFAULT_VARIANT_MAPPING);
